<template>
  <div>
    <gt-memberDig @memberUrl="memberUrl"></gt-memberDig>
    <div v-if="memberInfo.cardNo" class="srcoll">
      <div class="i_one">
        <img v-if="memberInfo.headImgUrl" :src="memberInfo.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120'" />
        <i v-else class="iconfont">&#xe719;</i>
      </div>
      <div class="li">
        <p>{{ memberInfo.nickName || '新增顾客' }}</p>
        <h5>{{ memberInfo.phone ? Lib.starPhone(memberInfo.phone) : '' }}</h5>
      </div>
      <div class="li">
        <p>会员等级：<samp class="themeFC" @click="openMemberDetails(memberInfo.phone,memberInfo.memberId)">{{ memberInfo.gradeName }}</samp>（{{ memberInfo.discount || 0 }}折）</p>
        <h5>会员余额：￥{{ (memberInfo.money*1).toFixed(2) || '0.00' }}<span style="cursor: pointer;margin-left:5px;" class="themeFC" @click="newGetMemberUrl(1)">充值</span></h5>
      </div>
      <div class="li">
        <p>会员积分：{{ memberInfo.integral || 0 }}</p>
        <h5>可用优惠券：{{ memberInfo.couponCount || 0 }}张</h5>
      </div>
      <div class="li">
        <p>消费汇总：￥{{ (memberInfo.expenseTotal*1).toFixed(2) || '0.00' }}（{{ memberInfo.expenseCount || 0 }}次）</p>
        <h5>上次消费：￥{{ (memberInfo.lastAmount*1).toFixed(2) || '0.00' }}（{{ memberInfo.lastTime || '无' }}）</h5>
      </div>
      <div class="li" style="padding-right: 30px;">
        <p>有效套餐：{{ memberInfo.packageCount || 0 }}个{{ memberInfo.packageResidueCount===-1?'（无限次数）':`（剩余${memberInfo.packageResidueCount}次）` }}</p>
        <h5>即将到期套餐：{{ memberInfo.minPastTimeCount || 0 }}个</h5>
      </div>
      <div class="i_two">
        <el-dropdown trigger="click" @command="chooseDropdown">
          <el-button type="primary">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="edit" command="顾客编辑">顾客编辑</el-dropdown-item>
            <el-dropdown-item command="会员充值">会员充值</el-dropdown-item>
            <el-dropdown-item command="新增会员">新增会员</el-dropdown-item>
            <el-dropdown-item v-if="resetInfo" command="清空顾客">清空顾客</el-dropdown-item>
            <el-dropdown-item command="会员详情">会员详情</el-dropdown-item>
            <el-dropdown-item command="顾客详情">顾客详情</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div v-else class="srcoll">
      <div class="i_one">
        <img v-if="memberInfo.headImgUrl" :src="memberInfo.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120'" />
        <i v-else class="iconfont">&#xe719;</i>
      </div>
      <div class="li">
        <p v-show="editStatus == 1">
          {{ memberInfo.nickName || '新增顾客' }}
          <i class="el-icon-edit i_three" @click="editUsername(2)"></i>
        <!-- <samp class="themeFC" style="margin-left: 15px;cursor: pointer;" @click="registerMember">注册会员</samp> -->
        </p>
        <p v-show="editStatus == 2">
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <el-input v-model="memberInfo.nickName" class="liBtn" size="mini" placeholder="请输入顾客姓名" :maxlength="15" @keyup.enter.native="Lib.keyboardBlur">
          </el-input>
          <yz-btn type="primary" @click="editUsername(1)">确定</yz-btn>
        </p>
        <h5>{{ form.phone ? Lib.starPhone(form.phone) : Lib.starPhone(searchVal) }}</h5>
      </div>
      <div class="li">
        <p>消费汇总：￥{{ (memberInfo.expenseTotal*1).toFixed(2) || '0.00' }}（共{{ memberInfo.expenseCount || 0 }}次）</p>
        <h5>上次消费：￥{{ (memberInfo.lastAmount*1).toFixed(2) || '0.00' }}（{{ memberInfo.lastTime || '无' }}）</h5>
      </div>
      <div class="li" style="padding-right: 30px;">
        <p>有效套餐：{{ memberInfo.packageCount || 0 }}个{{ memberInfo.packageResidueCount===-1?'（无限次数）':`（剩余${memberInfo.packageResidueCount}次）` }}</p>
        <h5>即将到期套餐：{{ memberInfo.minPastTimeCount || 0 }}个</h5>
      </div>
      <div class="i_two">
        <el-dropdown @command="chooseDropdown">
          <el-button type="primary">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="edit" command="顾客编辑">顾客编辑</el-dropdown-item>
            <el-dropdown-item command="会员充值">会员充值</el-dropdown-item>
            <el-dropdown-item command="新增会员">新增会员</el-dropdown-item>
            <el-dropdown-item v-if="resetInfo" command="清空顾客">清空顾客</el-dropdown-item>
            <el-dropdown-item command="顾客详情">顾客详情</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog class="memberDialog" :title="memberStatus == 1 ? '会员充值' : '新增会员'" :visible.sync="memberDialog" :append-to-body="true">
      <iframe :src="memberManageSrc"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import { getMemberUrl } from '../../api';

export default {
  props: {
    memberInfo: {
      type: Object,
      default: Object
    },
    searchVal: {
      type: String,
      default: String
    },
    resetInfo: {
      type: Function,
      default: null
    },
    edit: {
      type: Function,
      default: null
    },
    refreshData: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      editStatus: 1, // 编辑用户姓名状态   1未编辑  2编辑中
      form: {
        memberDialog: false,
        phone: ''
      },
      memberDialog: false,
      memberManageSrc: '',
      memberStatus: 0,
    };
  },
  watch: {
    memberDialog(val) {
      if (val == false) {
        this.refreshData();
      }
    }
  },
  methods: {
    chooseDropdown(val) {
      if (val === '顾客编辑') {
        this.edit(this.memberInfo.phone || this.form.phone || this.searchVal);
      } else if (val === '新增会员') {
        this.newGetMemberUrl(0);
      } else if (val === '清空顾客') {
        this.resetInfo();
      } else if (val === '会员充值') {
        this.newGetMemberUrl(1);
      } else if (val === '顾客详情') {
        this.customerDetails(this.memberInfo.phone || this.form.phone || this.searchVal);
      } else if (val === '会员详情') {
        this.openMemberDetails(this.memberInfo.phone, this.memberInfo.memberId);
      }
    },
    // 打开会员详情页面
    openMemberDetails(phone, memberId) {
      window.sessionStorage.memberPhone = phone;
      window.sessionStorage.memberId = memberId;
      this.$router.push({
        name: 'customer-member'
      });
    },
    // 会员充值
    newGetMemberUrl(val) {
      if (val == 1) {
        if (this.Lib.checkPower('beauty-2-czhy') == false) return;
      }
      const data = { type: val };
      this.memberStatus = val;
      getMemberUrl(data).then((res) => {
        if (res.code == 0) {
          this.memberManageSrc = `${res.data}?phone=${this.memberInfo.phone}&hideBack=1&shopId=${window.sessionStorage.shopId}`;
          this.memberDialog = true;
        } else {
          console.log(res);
        // this.$message(res.msg)
        }
      });
    },
    // 顾客详情
    customerDetails(phone) {
      if (this.Lib.checkPower('beauty-2-ckgkxq2') == false) return;
      window.sessionStorage.customerPhone = phone;
      this.$router.push({
        name: 'customer-details'
      });
    },
    // 修改用户姓名
    editUsername(val) {
      this.editStatus = val;
    },
    // 注册会员
    registerMember() {
      this.form.phone = this.searchVal;
      this.form.memberDialog = true;
    },
    // 调用公共组件--赋值
    memberUrl(list) {
      this.form = list;
    },
  }
};
</script>
<style lang="less" scoped>
.srcoll {
  width: 100%;
  height: 60px;
  padding: 10px 0;
  background-color: #f5f7fa;
  display: -webkit-box;
  margin: 0 0 10px 0;
  overflow-x: visible;
  overflow-y: hidden;
  position: relative;
  .i_one {
    float: left;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 20px 0 30px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    i {
      color: #999;
      font-size: 28px;
    }
  }
  .li {
    float: left;
    padding: 8px 30px 8px 0;
    position: relative;
    h5 {
      font-size: 14px;
      color: #333;
      height: 16px;
      line-height: 16px;
    }
    p {
      font-size: 14px;
      color: #333;
      height: 28px;
      line-height: 28px;
      .liBtn {
        float: left;
        width: 180px;
        margin-right: 10px;
      }
      .i_three {
        font-size: 16px;
        color: #fd5c8c;
        padding-left: 5px;
        cursor: pointer;
      }
      span {
        float: right;
        font-size: 12px;
        background-color: #ffe9ee;
        color: #fd5c8c;
        height: 19px;
        line-height: 19px;
        border-radius: 8px;
        margin-left: 5px;
        padding: 0 5px 0 23px;
        i {
          position: relative;
          display: block;
          float: left;
          font-size: 12px;
          margin: -2px 0 0 -25px;
          background-color: #ffe9ee;
          text-align: center;
          width: 23px;
          height: 23px;
          line-height: 23px;
          border-radius: 50%;
        }
      }
      samp {
        cursor: pointer;
      }
    }
  }
  .i_two {
    float: right;
    width: 89px;
    height: 40px;
    line-height: 40px;
    color: #333;
    padding: 10px 20px 0 0;
    background-color: #f5f7fa;
    position: sticky;
    right: 0;
    margin-left: auto;
  }
}
</style>
<style>
.srcoll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.srcoll::-webkit-scrollbar-track-piece {
  background-color: #f5f7fa;
}
.srcoll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.srcoll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
</style>
